<template>
    <div class="footer">
        <footer class="w1200">
    <!-- style="width:230px;margin:0 auto;height:30px;line-height:30px;text-align:center;" -->
            <div>
                <a target="_blank" class="juzhong"
                 href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037965" 
                 >
                 <img src="../../static/img/beian.png" alt="" style="float:left;margin-top:5px;">
                  <span  style="display:inline-block;float:left;margin-left:5px;color:#939393;">京公网安备 11010502037965号</span>
                </a>
            </div>
            <p>京ICP备18049484号-1</p>
            <p class="zs" @click="$router.push({path:'/gxqy'})">"中关村高新技术企业"证书</p>
            <p>Copyright © 2018 北京飞猪科技有限公司</p>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'footer1',
  methods: {
    // skip (url) {
    //   location.href = url
    // }
  }
}
</script>
<style lang="scss" scoped>
.footer{
    max-width: 1920px;
    margin: 0 auto;
    width: 100%;
    background-color: #242c39;
    footer {
        // height: 140px;
        font-size: 12px;
        text-align: center;
        background-color: #242c39;
        color: #fff;
        box-sizing: border-box;
        padding:20px 0 10px 0;
        p{
            width: 100%;
            line-height: 30px;
        }
        .zs{
            cursor: pointer;
        }
        div{
            position: relative;
            height:30px;
            line-height:30px;
            .juzhong{
                display: block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue